import gql from 'graphql-tag'

import { UserExperienceFragment } from 'store/fragments'

export const UpdateUserExperience = gql`
	mutation setExperience(
			$id: String,
						$title:String,
						$description:String,
						$locationId:String,
						$position:String,
						$company:String,
						$startDate:  Datetime,
						$endDate: Datetime,
						$isPresent:Boolean,
						$isCurrent:Boolean,
	) {
		# {
#   updateExperienceCollection(
#     filter:{
#       profile: {eq:"profileid"}
#       isCurrent:{eq:true}
#     }
#     set:{
#       isCurrent: false
#     }
#   ){
#     affectedCount
#     records{
#       id
#     }
#   }
  
  insertIntoExperienceCollection(
    objects:{
     	id:$id,
						title:$title
						description:$description
						location:$locationId
						position:$position
						company:$company
						startDate:$startDate,
						endDate:$endDate,
						isPresent:$isPresent
						isCurrent:$isCurrent
    }
  ){
    affectedCount
    records{
      id
      title
    }
  }
# }
	}
	${UserExperienceFragment}
`
export const DeleteUserExperience = gql`
	mutation deleteFromExperienceCollection($id: String!) {
		deleteFromExperienceCollection(filter:{id:{eq:$id}}) {			
			records{...UserExperience}
		}
	}
	${UserExperienceFragment}
`
